"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addDoctorToFavoritesApi = addDoctorToFavoritesApi;
exports.callAllSpecialityListApi = callAllSpecialityListApi;
exports.callCmsDoctorDetailsApi = callCmsDoctorDetailsApi;
exports.callDoctorDetailsApi = callDoctorDetailsApi;
exports.callDoctorFilterApi = callDoctorFilterApi;
exports.callDoctorListApi = callDoctorListApi;
exports.callFacilityDoctorListApi = callFacilityDoctorListApi;
exports.callMyDoctorListApi = callMyDoctorListApi;
exports.callSpecialityDoctorListApi = callSpecialityDoctorListApi;
exports.getDoctorListFacility = getDoctorListFacility;
exports.getDoctorListSpeciality = getDoctorListSpeciality;
exports.getPastDoctorsList = getPastDoctorsList;
exports.removeDoctorFromFavoritesApi = removeDoctorFromFavoritesApi;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
var _utils = require("../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { apiCall } from '../../../common/api/api';

function callDoctorFilterApi(requestParams, tokenData) {
  let queryString = '?';
  for (const key in requestParams) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + requestParams[key];
    } else {
      queryString = queryString + '&' + key + '=' + requestParams[key];
    }
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_DOCTOR_FILTER_LIST_API}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function callDoctorListApi(requestParams, tokenData) {
  let queryString = '?';
  if ((0, _utils.isMobile)()) {
    for (const key in requestParams) {
      if (queryString === '?') {
        queryString = queryString + key + '=' + encodeURIComponent(requestParams[key]);
      } else {
        queryString = queryString + '&' + key + '=' + encodeURIComponent(requestParams[key]);
      }
    }
  } else {
    for (const key in requestParams) {
      if (queryString === '?') {
        queryString = queryString + key + '=' + requestParams[key];
      } else {
        queryString = queryString + '&' + key + '=' + requestParams[key];
      }
    }
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_DOCTOR_LIST_API}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function callMyDoctorListApi(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_MY_DOCTOR_LIST_API}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function callSpecialityDoctorListApi(requestParams, tokenData) {
  const {
    speciality
  } = requestParams;
  delete requestParams.speciality;
  let queryString = '?';
  for (const key in requestParams) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + requestParams[key];
    } else {
      queryString = queryString + '&' + key + '=' + requestParams[key];
    }
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_SPECIALITY_DOCTOR_LIST_API}${speciality}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function callFacilityDoctorListApi(requestParams, tokenData) {
  let queryString = '?';
  for (const key in requestParams) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + requestParams[key];
    } else {
      queryString = queryString + '&' + key + '=' + requestParams[key];
    }
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_FACILITY_DOCTOR_LIST_API}${(requestParams === null || requestParams === void 0 ? void 0 : requestParams.specificFacility) || (requestParams === null || requestParams === void 0 ? void 0 : requestParams.facility)}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function callAllSpecialityListApi(requestParams, tokenData) {
  let queryString = '?';
  for (const key in requestParams) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + requestParams[key];
    } else {
      queryString = queryString + '&' + key + '=' + requestParams[key];
    }
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_ALL_SPECIALITY_LIST_API}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function callDoctorDetailsApi(queryParam, tokenData) {
  let queryString = '?';
  for (const key in queryParam) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + queryParam[key];
    } else {
      queryString = queryString + '&' + key + '=' + queryParam[key];
    }
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_DOCTOR_DETAILS_API}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function callCmsDoctorDetailsApi(queryParam, tokenData) {
  let queryString = '?';
  for (const key in queryParam) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + queryParam[key];
    } else {
      queryString = queryString + '&' + key + '=' + queryParam[key];
    }
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_CMS_DOCTOR_DETAILS_API}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function addDoctorToFavoritesApi(doctorId, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.ADD_OR_REMOVE_DOCTOR_API}${doctorId}/favorite`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.POST });
}
function removeDoctorFromFavoritesApi(doctorId, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.ADD_OR_REMOVE_DOCTOR_API}${doctorId}/favorite`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.DELETE;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.DELETE });
}
function getPastDoctorsList(requestParams, tokenData) {
  let queryString = '?';
  for (const key in requestParams) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + requestParams[key];
    } else {
      queryString = queryString + '&' + key + '=' + requestParams[key];
    }
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_DOCTOR_LIST_API}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getDoctorListSpeciality({
  params,
  speciality
}, tokenData) {
  let queryString = '?';
  for (const key in params) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + params[key];
    } else {
      queryString = queryString + '&' + key + '=' + params[key];
    }
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_DOCTOR_LIST_SPECIALITY_API}/${speciality}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getDoctorListFacility({
  params,
  facility
}, tokenData) {
  let queryString = '?';
  for (const key in params) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + params[key];
    } else {
      queryString = queryString + '&' + key + '=' + params[key];
    }
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_DOCTOR_LIST_FACILITY_API}/${facility}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}